var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('van-nav-bar',{attrs:{"fixed":"","placeholder":"","title":_vm.currTitle,"left-arrow":_vm.showBack},on:{"click-left":_vm.backpage}}),_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }